"use strict";

exports.__esModule = true;
exports.EnvContext = void 0;
var _Utils = require("../../../Utils");
var EnvContext = exports.EnvContext = (0, _Utils.createEnhancedContext)({
  propName: "env"
});